import { Container, Grid, Hidden } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import { ReactComponent as HeinsohnWelcome } from 'assets/images/imagenLogin.svg';
import { ReactComponent as HeinsohnLogo } from 'assets/images/logoHeinsohnBlanco.svg';
import { AuthContext } from 'auth/AuthContext';
import authService from 'auth/AuthService';
import { LoginBusiness } from 'business/business/LoginBusiness';
import {
  ButtonBase,
  Loader, TextBase,
} from 'components';
import { abreviaturas, masterMessages, messages } from 'constantes';
import { Field, Form, Formik } from 'formik';
import Cookie from 'js-cookie';
import PropTypes from 'prop-types';
import React, {
  useContext, useEffect, useState,
} from 'react';
import { useHistory } from 'react-router-dom';
import { withNotification } from 'wrappers';
import * as Yup from 'yup';
// eslint-disable-next-line import/no-extraneous-dependencies

// Estilos de la pagina
const useStyles = makeStyles((theme) => ({
  companyImage: {
    background: 'linear-gradient(90deg, #E02A58, #C00333)',
    borderTopLeftRadius: '1.20rem',
    borderBottomLeftRadius: '1.20rem',
    boxShadow: '0rem 0.188rem 0.375px #9CBEDB29',
    paddingTop: '6.99rem',
    textAlign: 'center',
    width: '95%',
    height: 'calc(100vh - 50px)',
  },
  headerImage: {
    width: '100%',
    marginTop: '-4.7rem',
    marginBottom: '0rem',
  },
  welcomeLogo: {
    width: '70%',
    height: 'calc(100vh - 180px)',
  },
  formCompany: {
    backgroundColor: '#FFFFFF',
    borderRadius: '0.625rem',
    boxShadow: '0px 12px 20px #53546A',
    padding: '20px 50px 30px 50px',
    marginTop: 60,
    textAlign: 'center',
    [theme.breakpoints.up('xs')]: {
      marginTop: '10%',
      width: '80%',
      height: 'auto',
      margin: '10% auto',
    },
    [theme.breakpoints.up('md')]: {
      marginTop: '5%',
      width: '95%',
      height: 'auto',
      margin: '10% auto',
    },
    [theme.breakpoints.up('lg')]: {
      marginTop: '5%',
      width: '95%',
      height: '10% auto',
    },
    [theme.breakpoints.up('xl')]: {
      marginTop: '20%',
      marginBottom: '20%',
      width: '80%',
      height: 'auto',
      margin: '10% auto',
    },
  },
  containerLogin: {
    position: 'absolute',
    height: 'calc(100vh - 40px)',
    overflow: 'hidden',
    [theme.breakpoints.up('xs')]: {
      overflow: 'inherit',
    },
  },
  login: {
    textAlign: 'center',
    margin: '0 auto',
    [theme.breakpoints.up('xs')]: {
      marginTop: '0',
      width: '100%',
    },
    [theme.breakpoints.up('md')]: {
      marginTop: '12%',
      width: '70%',
    },
    [theme.breakpoints.up('lg')]: {
      marginTop: '12%',
      width: '70%',
    },
    [theme.breakpoints.up('xl')]: {
      marginTop: '12%',
      width: '90%',
    },
  },
  welcome: {
    fontSize: '2.4rem',
    fontWeight: 'bold',
    color: '#3E3E3C',
    lineHeight: '100%',
  },
  lineH: {
    width: 33,
    height: 2,
    background: 'linear-gradient(90deg, #E02A58, #C00333)',
    opacity: 1,
    margin: 'auto',
    marginTop: 11,
  },
  saludo: {
    fontSize: 20,
    color: '#3E3E3C',
    fontWeight: 'bold',
    marginTop: 20,
  },
  message: {
    fontSize: 13,
    fontWeight: 'normal',
    color: '#3E3E3C',
    marginTop: 20,
  },
}));

/**
 * @desc Objeto que evalua si los campos del formulario son correctos
 */
const validationSchema = Yup.object({
  username: Yup.string().required('El campo es requerido'),
  password: Yup.string().required('El campo es requerido'),
});

function SignIn({ appError }) {
  // Mensajes a mostrar
  const { auth: { login: formMessages }, buttons } = masterMessages;
  const classes = useStyles();
  const history = useHistory();
  const [loading, setLoading] = useState(false);
  const { dispatch } = useContext(AuthContext);
  const solicitudId = Cookie.get(abreviaturas.DEFAULT_SOLICITUD_ID);
  const values = {
    password: '',
    username: '',
  };
  const { username, password } = values || {};

  useEffect(() => {
    const {
      REACT_APP_BUILD_ID: buildId = 'local',
      REACT_APP_GIT_COMMIT: gitCommit = 'unknown',
      REACT_APP_BUILD_DATE: buildDate = 'unknown',
    } = process.env;
    console.log(`[SignIn] Build ${buildId} - commit ${gitCommit.substring(0, 7)} - ${buildDate}`);
  }, []);

  const loginKeycloak = (dataConn, formValues) => {
    const { username: userName } = formValues || {};
    const { data: { issuer, clientId, scopes }, url } = dataConn.keycloakData;
    const settings = {
      authority: issuer,
      client_id: clientId,
      redirect_uri: `${window.location.origin}/apiv1/keycloackLogin`,
      response_type: 'code',
      scope: 'openid profile',
    };

    const keycloakURL = `${issuer}/protocol/openid-connect/auth?client_id=${clientId}&login_hint=${username}&redirect_uri=${`${window.location.origin}/apiv1/keycloackLogin`}&response_type=code&scope=${scopes.join(' ')}`;

    // Guardo el objeto globalmente y el usuario logueado
    Cookie.set(abreviaturas.SETTINGS_OIDC, { settings, url });
    Cookie.set(abreviaturas.USERNAME, userName);

    setTimeout(() => { window.location.href = keycloakURL; }, 2000);
  };

  /**
   * @name onSubmit
   * @desc Realiza consumo de servicios para enviar datos al api de logueo y consulta de dominio
   * @param formValues
   * @returns {Promise<void>}
   */
  const onSubmit = async (formValues = {}) => {
    const { username: userForm } = formValues || {};
    setLoading(true);
    try {
      console.log('userForm', userForm);
      // Se verifica si el dominio pertenece a keycloak
      const resDominioAuth = await LoginBusiness.fetchClientDomain(userForm);
      if (resDominioAuth) {
        const dataLogin = JSON.parse(resDominioAuth);
        if (dataLogin.isKeycloak) {
          loginKeycloak(dataLogin, formValues);
        } else {
          const res = await LoginBusiness.loginLionClient(dataLogin.url, formValues);
          const resp = JSON.parse(res);
          Cookie.set(abreviaturas.SETTINGS_OIDC, null);
          if (resp.resultado === abreviaturas.STATUS_APROBADO) {
            dispatch({ type: abreviaturas.TYPE_LOGIN, payload: true });
            authService.storeSessionData(resp);
            history.push(`/apiv1/validation/${solicitudId}`);
          } else if (resp.resultado === abreviaturas.STATUS_FALLIDO) {
            appError(messages.errors.login);
            setLoading(false);
          }
        }
      }
    } catch (e) {
      setLoading(false);
      appError(messages.errors.submitting);
    }
  };

  return loading ? <Loader /> : (
    <>
      <div className="containerWrapper">
        <div className={classes.containerLogin}>
          <Grid container spacing={2}>
            <Hidden only={['xs']}>
              <Grid item sm={6} md={6} xl={6}>
                <Container className={classes.companyImage}>
                  <HeinsohnLogo className={classes.headerImage} />
                  <HeinsohnWelcome className={classes.welcomeLogo} />
                </Container>
              </Grid>
            </Hidden>
            <Grid item xs={12} sm={6} md={6} xl={6}>
              <Container className={classes.formCompany}>
                <div className={classes.login}>
                  <h1 className={classes.welcome}>{formMessages.title}</h1>
                </div>
                <hr className={classes.lineH} align="left" />
                <p className={classes.saludo}>{formMessages.subtitle}</p>
                <p className={classes.message}>{formMessages.message}</p>

                <Formik
                  enableReinitialize
                  initialValues={{
                    username, password,
                  }}
                  validationSchema={validationSchema}
                  onSubmit={onSubmit}
                >
                  {(subProps) => (
                    <Form>
                      <Grid container spacing={2}>
                        <Grid item xs={12} md={12}>
                          {/*
                            type="text" y no "email": la validacion nativa de
                            HTML solo acepta ASCII antes de la arroba, asi que
                            un usuario como kvirguez@... (con diereis) queda
                            bloqueado por el navegador y no puede ingresar. El
                            campo es un usuario, no un correo: el esquema Yup
                            solo exige que no este vacio.
                            inputMode conserva el teclado con @ en moviles.
                            OJO: no quitar el type. TextBase resuelve
                            type={iconSecurity ? 'password' : type} y el spread
                            de props es lo unico que lo sobreescribe; sin el, el
                            campo de usuario se renderiza como contrasena.
                          */}
                          <Field
                            label="Ingresa tu usuario"
                            name="username"
                            type="text"
                            inputProps={{ inputMode: 'email' }}
                            component={TextBase}
                            userLoginentry
                          />
                        </Grid>
                        <Grid item xs={12} md={12}>
                          <Field label="Ingresa tu contraseña" name="password" component={TextBase} passLoginentry />
                        </Grid>
                        <Grid container justifyContent="center" style={{ marginBottom: 15 }}>
                          <Grid item xs={6} md={6}>
                            <ButtonBase
                              disabled={subProps.isSubmitting}
                              caption={buttons.login}
                              colorBase={abreviaturas.DEFAULT_RED_COLOR}
                            />
                          </Grid>
                        </Grid>
                      </Grid>
                    </Form>
                  )}
                </Formik>
              </Container>
            </Grid>
          </Grid>
        </div>
      </div>
    </>
  );
}

SignIn.propTypes = {
  appError: PropTypes.func.isRequired,
};

export default withNotification(SignIn);
